export default __webpack_public_path__ + "static/media/park_central.2d36d541.jpg";